import React from 'react';
import FontAwesome from 'react-fontawesome';

import './styles.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, info);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="error-boundary-container">
          <FontAwesome
            className="error-boundary-icon"
            name="exclamation-triangle"
            size="3x"
            style={{ color: '#ff0000' }}
          />
          <h3>Something went wrong.</h3>
          <h5>We are working on resolving the issue.</h5>
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/index.js